import { printFunctionCall, printScript } from './printScript';
// ----- WARNING -----
// This is a very sensitive fraction of code.
// Any changes to this file must be tested directly in product before merging.
// The scripts printed here might differ from what we observe in our internal tests
// due to minimification, for example.

export var GLOBAL_MEDIA_CARD_SSR = 'mediaCardSsr';
export var GLOBAL_MEDIA_NAMESPACE = '__MEDIA_INTERNAL';
export function getMediaGlobalScope() {
  var globalScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
  var namespace = '__MEDIA_INTERNAL';
  if (!globalScope[namespace]) {
    globalScope[namespace] = {};
  }
  return globalScope[namespace];
}
export function getMediaCardSSR() {
  var globalScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var globalMedia = getMediaGlobalScope(globalScope);
  // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
  var key = 'mediaCardSsr';
  if (!globalMedia[key]) {
    globalMedia[key] = {};
  }
  return globalMedia[key];
}
var dashed = function dashed(param) {
  return param ? "-".concat(param) : '';
};
export var getKey = function getKey(_ref, resizeMode) {
  var id = _ref.id,
    collectionName = _ref.collectionName,
    occurrenceKey = _ref.occurrenceKey;
  return "".concat(id).concat(dashed(collectionName)).concat(dashed(occurrenceKey)).concat(dashed(resizeMode));
};
export var storeDataURI = function storeDataURI(key, paramDataURI, paramMode, paramSrcSet, dimensions, error) {
  var featureFlags = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var globalScope = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : window;
  var mediaCardSsr = getMediaCardSSR(globalScope);
  if (featureFlags['media-perf-uplift-mutation-fix']) {
    var _prevData$dimensions, _script;
    var prevData = mediaCardSsr[key];
    var isPreviousImageLarger = (prevData === null || prevData === void 0 ? void 0 : prevData.mode) === paramMode && prevData && ((_prevData$dimensions = prevData.dimensions) === null || _prevData$dimensions === void 0 ? void 0 : _prevData$dimensions.width) && (dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) && prevData.dimensions.width > dimensions.width;
    var srcSet = isPreviousImageLarger ? prevData === null || prevData === void 0 ? void 0 : prevData.srcSet : paramSrcSet;
    var dataURI = isPreviousImageLarger ? prevData === null || prevData === void 0 ? void 0 : prevData.dataURI : paramDataURI;
    var img = (_script = script) === null || _script === void 0 || (_script = _script.parentElement) === null || _script === void 0 ? void 0 : _script.querySelector('img');
    if (img && dataURI) {
      img.src = dataURI;
    }
    if (img && srcSet) {
      img.srcset = srcSet;
    }
    var loadPromise = new Promise(function (resolve, reject) {
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      img === null || img === void 0 || img.addEventListener('load', function () {
        resolve(void 0);
      });

      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      img === null || img === void 0 || img.addEventListener('error', function () {
        reject(new Error('Failed to load image'));
      });
    });
    mediaCardSsr[key] = isPreviousImageLarger ? prevData : {
      dataURI: dataURI,
      dimensions: dimensions,
      error: error,
      srcSet: srcSet,
      loadPromise: loadPromise
    };
  } else {
    mediaCardSsr[key] = {
      dataURI: paramDataURI,
      dimensions: dimensions,
      error: error
    };
  }
};
var generateScript = function generateScript(identifier, dataURI, mode, srcSet, dimensions, error) {
  var featureFlags = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var functionCall = printFunctionCall(storeDataURI, getKey(identifier, mode), dataURI, mode, srcSet, dimensions, error, featureFlags);
  return printScript([getMediaCardSSR.toString(), getMediaGlobalScope.toString(), functionCall]);
};
export var generateScriptProps = function generateScriptProps(identifier, dataURI, mode, srcSet, dimensions, error) {
  var featureFlags = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  return {
    dangerouslySetInnerHTML: {
      __html: generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
    }
  };
};